import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { postSession, applyReferralCode } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { getStoredRef, clearStoredRef } from "@/lib/referral";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, refreshFavs } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const session_id = params.get("session_id");
    if (!session_id) {
      navigate("/");
      return;
    }
    (async () => {
      try {
        const { user } = await postSession(session_id);
        setUser(user);
        await refreshFavs();
        // Apply pending referral code (if any)
        const ref = getStoredRef();
        if (ref) {
          try {
            const r = await applyReferralCode(ref);
            if (r?.ok) toast.success("Bonus deal pack unlocked 🎁");
            clearStoredRef();
          } catch {}
        }
        // strip hash and go to dashboard
        window.history.replaceState({}, "", "/dashboard");
        navigate("/dashboard", { state: { user }, replace: true });
      } catch (e) {
        // Clear the hash first — otherwise App.js sees session_id in location.hash and
        // keeps rendering AuthCallback in a loop, leaving the user stuck on "Clipping…"
        window.history.replaceState({}, "", "/");
        try {
          toast.error(e?.response?.data?.detail || "Sign-in failed — please try again");
        } catch {}
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser, refreshFavs]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f6f4f0]">
      <div className="border-2 border-dashed border-black p-10 bg-white hard-shadow" data-testid="auth-callback">
        <p className="serif text-3xl">Clipping your session...</p>
        <p className="mono text-xs tracking-widest text-[#5c5c5c] mt-2">
          ONE MOMENT
        </p>
      </div>
    </div>
  );
}
